import React from 'react';
import {Link, useLocation} from 'react-router-dom';

import { useAuth } from '../../hooks/AuthContext';

import { Header } from './styles';

const ChildPages = ({ active }) => {
  const { user } = useAuth();
  return (
    <Header>
      <Link  to={user.type === 2 ? "/childDashboard" : "/dashboard"} className={(active === "dashboard") ? "active" : ""}>
        <div className="flex-div">Missões</div>
      </Link>
      <Link to="/physical-activity" className={(active === "physical") ? "active" : ""}>
        <div className="flex-div">Atividade Física</div>
      </Link>
      <Link to="/sleep-habits" className={(active === "sleep") ? "active" : ""}>
        <div className="flex-div">Hábitos de sono</div>
      </Link>
    </Header>
  );
}

export default ChildPages;